import { useEffect, useState } from 'react';
import PurchaseType from '../../Purchase/PurchaseType';
export default (basket, callback) => {
    const [amountOfReview, setAmountOfReview] = useState(null);
    const [amountOfAdvice, setAmountOfAdvice] = useState(null);
    useEffect(() => {
        let newAmountOfReview = 0;
        let newAmountOfAdvice = 0;
        basket.items.forEach((item) => {
            if (item.purchase_type === PurchaseType.REVIEW) {
                newAmountOfReview += 1;
            }
            if (item.purchase_type === PurchaseType.ADVICE) {
                newAmountOfAdvice += 1;
            }
        });
        // If this is the first run through, just set the states without doing the callback.
        if (amountOfReview === null || amountOfAdvice === null) {
            setAmountOfReview(newAmountOfReview);
            setAmountOfAdvice(newAmountOfAdvice);
        }
        else if (newAmountOfReview !== amountOfReview || newAmountOfAdvice !== amountOfAdvice) {
            setAmountOfReview(newAmountOfReview);
            setAmountOfAdvice(newAmountOfAdvice);
            callback();
        }
    }, [basket]);
};
